import React from 'react'
import { Card } from 'react-bootstrap'

const PhotoRealistic = () => {
	return (
		<>
			<Card className="text-center rounded-0 no-border photo-realistic-card container">
				<Card.Body>
					<Card.Title className='photo-realistic-title'>Bringing virtual worlds to life</Card.Title>
					<Card.Text className='photo-realistic-content pt-4'>
						Without graphics, a virtual world would just be a digital black hole. Thanks to talented graphic artists and designers, we take real and fantasy environments and bring them into virtual reality. 
					</Card.Text>
					<Card.Text className='photo-realistic-content'>
						Whether a project needs one machine, one room, a whole buil ding, an entire city, a fantasy island, or anything in between, Paracosma has experience building realistic 3D graphics that make augmented and virtual reality applications an awe - inspiring experience for users.
					</Card.Text>
				</Card.Body>
			</Card>
		
		</>
	)
}

export default PhotoRealistic
